<template>
    <div class="AddWithdrawalAddress">
        <el-dialog
            :title="$t('myAccount.text122')"
            v-model="AddWithdrawalAddressModelFlag"
            width='500px'
            class="dialog-box"
            :close-on-click-modal="false"
            destroy-on-close
            @closed="beforeClose"

        >
            <div class="box-inline">
                <div class="dialog-left">
                    <div class="label">
                        {{$t('myAccount.text112')}}
                    </div>
                </div>
                <div class="dialog-right">
                    <div class="value">
                        <el-select v-model="currency" class="m-2" :placeholder="$t('deposit.text27')">
                            <el-option
                            v-for="item in currencyList"
                            :key="item.currency"
                            :label="item.currency"
                            :value="item.currency"
                            />
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="box-inline">
                <div class="dialog-left">
                    <div class="label">
                        {{$t('withdraw.text60')}}
                    </div>
                </div>
                <div class="dialog-right">
                    <div class="value">
                        <el-input v-model="address" :placeholder="$t('myAccount.text117')" />
                    </div>
                </div>
            </div>
            <div class="box-inline">
                <div class="dialog-left">
                    <div class="label">
                        {{$t('myAccount.text123')}}
                    </div>
                </div>
                <div class="dialog-right">
                    <div class="value">
                        <el-input v-model="remarks" @input="remarksInput" :placeholder="$t('myAccount.text124')" />
                    </div>
                </div>
            </div>
            <template #footer>
                <span class="dialog-footer">
                <el-button @click="Cancel">{{$t('trade.text72')}}</el-button>
                <el-button type="primary" :loading='loading' :disabled="!submitFlag" @click="Save"
                    >{{$t('myAccount.text118')}}</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import {
  ref,
  reactive,
  computed,
  inject,
  nextTick
} from 'vue';
import apiService from '@/api/request';
import { ElMessage } from 'element-plus'
import { useI18n } from "vue-i18n";

export default {
    name:'AddWithdrawalAddress',
    setup(){
        const emitt = inject('emitt');
        const { t } = useI18n()
        const AddWithdrawalAddressModelFlag = ref(false);
        const address = ref('');
        const remarks = ref('');
        const loading = ref(false)

        /**
         * 打开弹框-开始
         */ 
          emitt.$sub('openAddWithdrawalAddress', (val) => {
            AddWithdrawalAddressModelFlag.value = true;
            CurrencyType();
          });
        /**
         * 打开弹框-结束
         */ 
        /**
         * 获取币种-开始
         */
            const currencyList = ref([]);
            const currency = ref('');
            function CurrencyType(){
                apiService.CurrencyType().then(res => {
                    if(res.status == 1){
                        currencyList.value = res.data.listCurrencyType;
                    }else{
                        ElMessage({
                            message: res.message,
                            type: 'error',
                        });
                    }
                })
            }
        /**
         * 获取币种-结束
         */

         /**
         * 按钮提交条件-开始
         */
            const submitFlag = computed(() => {
                return  address.value != '' &&
                        currency.value != '' &&
                        remarks.value != ''
            })
        /**
         * 按钮提交条件-结束
         */

         /**
         * 添加地址-开始
         */
            function Save(){
                const params = {
                    remark: remarks.value,
                    address: address.value,
                    currency: currency.value,
                };
                apiService.WalletAddress(params, 'post').then((res) => {
                    if(res.status == 1){
                        AddWithdrawalAddressModelFlag.value = false;
                        Cancel();
                        emitt.$pub('getWalletAddress');
                         ElMessage({
                            message: t('myAccount.text125'),
                            type: 'success',
                        });
                    }else{
                        ElMessage({
                            message: res.message,
                            type: 'error',
                        });
                    }
                })
            }
        /**
         * 添加银行卡-结束
         */

        /**
         * 限制输入-开始
         */
            function remarksInput(v){
                let val = v;
                if (val.length > 10) {
                   val = val.substring(0, val.length - 1);
                }
                nextTick(() => {
                    remarks.value = val;
                });
            }
        /**
         * 限制输入-结束
         */
        
        function Cancel(){
            address.value = '' 
            currency.value = '' 
            remarks.value = ''
            AddWithdrawalAddressModelFlag.value = false;
        }

        /**
         * 关闭弹框-开始
         */
            function beforeClose(){
                address.value = '' 
                currency.value = '' 
                remarks.value = ''
            }
        /**
         * 关闭弹框-结束
         */
        return {
            AddWithdrawalAddressModelFlag,
            currencyList,
            currency,
            address,
            remarks,
            submitFlag,
            Save,
            loading,
            remarksInput,
            beforeClose,
            Cancel
        }
    }
}
</script>
<style lang="less" scoped>
.AddWithdrawalAddress{
    .box-inline{
        font-size: 14px;/*no*/
        display: flex;
        justify-content: space-between;
        height: 48px;/*no*/
        line-height: 48px;/*no*/
        .dialog-left{
            width: 196px;/*no*/
        }
        .dialog-right{
            width: 240px;/*no*/
        }
        .el-select{
            width: 100%;
        }
    }
}
</style>
